import { useState } from 'react';
import { NoSSR, useI18n, useUserInfo } from '@spot-fe/base-ui';
import { PrizeType, TaskType, EndProject, TaskStatus } from '@/apis';
import { safeToFormat1 } from '@/utils/number';

export const useText = (task: EndProject) => {
  const { t } = useI18n();
  const { isLogin } = useUserInfo();

  const getNameText = () => {
    const taskType = task.taskType;
    const prizeType = task.prizeType;
    const token = task.tokenList?.join('/');

    const nameTextMap: Record<TaskType, string> = {
      [TaskType.All]: t('depositTradeTokenToEarn', { token }),
      [TaskType.Trade]: t('tradeTokenToEarn', { token }),
      [TaskType.Deposit]: t('depositTokenToEarn', { token }),
    };

    const userTextMap: Record<PrizeType, string> = {
      [PrizeType.New]: `${t('newUsersOnly')} `,
      [PrizeType.Old]: `${t('existingUsersOnly')} `,
      [PrizeType.All]: '',
    };

    const userPrefix =
      taskType === TaskType.Deposit ? userTextMap[prizeType] : '';

    return userPrefix + nameTextMap[taskType];
  };

  const getYourPrizeText = () => {
    if (isLogin) {
      return `${safeToFormat1(task.rewardAmount, 4)} ${task.prizeToken}`;
    }
    return t('visAfterLg');
  };

  return {
    getNameText,
    getYourPrizeText,
  };
};
